






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getScreenshotBlob } from "../api";

@Component
export default class ScreenshotDialog extends Vue {
  @Prop({ required: true })
  value!: number;

  thumbnailSrc = "";

  get dialog() {
    return this.value > 0;
  }
  set dialog(val: boolean) {
    if (val) return;
    this.$emit("input", 0);
  }

  @Watch("value")
  private onDialog(val: boolean): void {
    if (!val) return;
    this.loadThumbnailSrc();
  }

  async loadThumbnailSrc() {
    if (this.value === 0) return;
    try {
      const blob = await getScreenshotBlob(this.value);
      var reader = new FileReader();
      reader.onload = () => {
        this.thumbnailSrc = reader.result as string;
      };
      reader.readAsDataURL(blob);
    } catch (e) {
      // silently fail
    }
  }
}
